import { Page, View, StyleSheet } from '@react-pdf/renderer'
import Header from './report-header'
import { PDFReportFeatureProps } from '..'
import ExecutiveSummaryDetail from './executive-summary-detail'
import ExecutiveSummaryScore from './executive-summary-score'
import LandPropertiesUsage from './land-properties-section'
import FloodRiskSection from './flood-risk-section'
import WeatherSection from './weather-section'
import { PDFFooter } from './footer'
import { pdfPadding } from '../_data/style-define'

const styles = StyleSheet.create({
  page: {
    backgroundColor: 'white',
    fontFamily: 'Wix Madefor Text',
    paddingBottom: 30,
  },
  content: {
    padding: 32,
    paddingTop: 0,
  },
})

export default function ReportPage({
  data,
  ability,
  type,
}: PDFReportFeatureProps) {
  if (type === 'parcel') {
    const property = data.property
    const name = ability.ownershipInformation ? property.data.name : ''
    return (
      <Page size="LETTER" style={styles.page}>
        <Header
          name={name}
          style={{
            paddingHorizontal: pdfPadding.xLarge,
            paddingVertical: pdfPadding.large,
            marginBottom: pdfPadding.xLarge,
          }}
        />
        <View style={styles.content}>
          <ExecutiveSummaryDetail data={data} ability={ability} type={type} />
          <ExecutiveSummaryScore data={data} ability={ability} type={type} />
          <LandPropertiesUsage data={data} ability={ability} type={type} />
          <FloodRiskSection data={data} ability={ability} type={type} />
          {/* <WeatherSection data={data} ability={ability} type={type} /> */}
        </View>
        <PDFFooter generatedBy={data.generatedBy} />
      </Page>
    )
  }

  return (
    <Page size="LETTER" style={styles.page}>
      <Header
        name={'RANCH REPORT'}
        style={{
          paddingHorizontal: pdfPadding.xLarge,
          paddingVertical: pdfPadding.large,
          marginBottom: pdfPadding.xLarge,
        }}
      />
      <View style={styles.content}>
        <ExecutiveSummaryDetail data={data} ability={ability} type={type} />
        <ExecutiveSummaryScore data={data} ability={ability} type={type} />
        <LandPropertiesUsage data={data} ability={ability} type={type} />
        <FloodRiskSection data={data} ability={ability} type={type} />
        {/* <WeatherSection data={data} ability={ability} type={type} />/ */}
      </View>
      <PDFFooter generatedBy={data.generatedBy} />
    </Page>
  )
}
